var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"outer-text-transition","enter-active-class":"animated fadeIn","leave-active-class":"animated fadeOut"}},[(_vm.show)?_c('div',{staticClass:"breathingCircleArea"},[_c('div',{class:{
      breathingCircleWrapper: true
    },style:({
      height: (_vm.size + "px"),
      width: (_vm.size + "px"),
      background: _vm.backgroundColor,
    })},[_c('div',{class:{
        breathingCircle: true
      },style:({
        height: (_vm.circleSize + "px"),
        width: (_vm.circleSize + "px"),
        background: _vm.circleColor,
        transitionDuration: (_vm.currentDuration + "ms"),
      })},[_c('div',{class:{
        breathingCircle: true
      },style:({
          height: ((_vm.circleSize === _vm.circleMaxSize ? _vm.circleSize*0.75 : _vm.circleSize) + "px"),
          width: ((_vm.circleSize === _vm.circleMaxSize ? _vm.circleSize*0.75 : _vm.circleSize) + "px"),
          background: _vm.circleColor,
          transitionDuration: (_vm.currentDuration + "ms"),
      })},[_c('div',{class:{
        breathingCircle: true
      },style:({
            height: ((_vm.circleSize === _vm.circleMaxSize ? _vm.circleSize*0.75*0.75 : _vm.circleSize) + "px"),
            width: ((_vm.circleSize === _vm.circleMaxSize ? _vm.circleSize*0.75*0.75 : _vm.circleSize) + "px"),
            background: _vm.circleColor,
            transitionDuration: (_vm.currentDuration + "ms"),
            color: _vm.innerTextColor
      })},[_vm._v("\n          "+_vm._s(_vm.innerCaption)+"\n        ")])])])]),_c('div',{staticClass:"outerCaptionWrapper"},[_c('transition',{attrs:{"name":"outer-text-transition","enter-active-class":"animated fadeIn","leave-active-class":"animated fadeOut"}},[(_vm.outerCaption)?_c('div',{staticClass:"breathingCircleOuterCaption",style:({color: _vm.outerTextColor})},[_vm._v(_vm._s(_vm.outerCaption))]):_vm._e()])],1)]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }